import {
  WSEmptyState,
  WSInfiniteScroll,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import { TaxWithholdingTransaction } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import { queriesTaxWithholdings } from "@query";
import { useModalCancelPendingWithholding } from "../../modals/ModalCancelPendingWithholding";
import { TableTransactions } from "./TableTransactions";

export const Transactions: React.FC = () => {
  const modalCancelPendingWithholding = useModalCancelPendingWithholding();

  const query =
    queriesTaxWithholdings.listTaxWithholdingTransactions.usePaginatedQuery();
  const items = query.flatData ?? [];

  const onCancel = (transaction: TaxWithholdingTransaction) => {
    modalCancelPendingWithholding.open({
      taxPaymentId: transaction.id,
      amount: Number(transaction.amount),
      currency: transaction.currency,
      date: transaction.effectiveAt
    });
  };

  if (query.isInitialLoading) {
    return (
      <WSList gap="XL">
        <WSText.Paragraph weight="medium">Transactions</WSText.Paragraph>
        <TableTransactions items={[]} loading />
      </WSList>
    );
  }

  if (query.isError) {
    return (
      <WSList gap="XL">
        <WSText.Paragraph weight="medium">Transactions</WSText.Paragraph>
        <WSEmptyState
          type="error"
          orientation="horizontal"
          title="Couldn't load transactions"
          description="Something went wrong loading your tax withholding activity. Please try again."
          actions={{
            buttons: [{ label: "Try again", onClick: () => query.refetch() }]
          }}
        />
      </WSList>
    );
  }

  if (items.length === 0) {
    return null;
  }

  return (
    <WSList gap="XL">
      <WSText.Paragraph weight="medium">Transactions</WSText.Paragraph>
      <WSInfiniteScroll
        onLoad={() => query.fetchNextPage()}
        loadMore={items.length > 0}
        endOfList={!query.hasNextPage}
        loading={!!query.isFetchingNextPage}
      >
        <TableTransactions items={items} onCancel={onCancel} />
      </WSInfiniteScroll>
    </WSList>
  );
};
